export const sagaActions = {
	FETCH_BUILDER_SAGA: 'FETCH_BUILDER_SAGA',
	FETCH_BUILDER_PARTS_SAGA: 'FETCH_BUILDER_PARTS_SAGA',
	CREATE_BUILDER_SAGA: 'CREATE_BUILDER_SAGA',
}
  